import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, RouterModule} from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { StudyMaterial } from '@edtech-ui/core/models/shared-resources/shared-resource.model';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';

@Component({
  selector: 'app-student-classroom-sharedresources',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, MatButtonModule],
  templateUrl: './student-classroom-sharedresources.component.html',
  styleUrl: './student-classroom-sharedresources.component.scss'
})
export class StudentClassroomSharedresourcesComponent implements OnInit, OnDestroy {
  classroomId: number | null = null;
  studyMaterials: StudyMaterial[] = [];
  private routerSub: Subscription | null = null;
  private lastFetchedClassroomId: number | null = null;
  private studentId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _toastr: ToastrService,
    private _authService: AuthServiceService
  ) { }

  ngOnInit() {
    this.studentId = this._authService.getUserId();

    if (!this.studentId) {
      this._toastr.error('Student ID not found. Please log in again.');
      this.router.navigate(['/login']);
      return;
    }

    this.route.parent?.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.classroomId = +id;

        if (this.classroomId !== this.lastFetchedClassroomId) {
          this.lastFetchedClassroomId = this.classroomId;
        }
      } else {
        this._toastr.error('Classroom ID not found in the URL.');
        this.router.navigate(['/student-dashboard/classrooms']);
      }
    });
  }

  formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }


	calculateDuration(start: string, end: string): string {
		if (!start || !end) return 'N/A';
		const diffMs = new Date(end).getTime() - new Date(start).getTime();
		const minutes = Math.floor(diffMs / 60000);
		return `${minutes} min`;
	}

	ngOnDestroy() {
		if (this.routerSub) {
			this.routerSub.unsubscribe();
		}
	}
	
}